var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v("Storage Finder")]),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('feature-categories',{attrs:{"categories":_vm.categories,"features":_vm.features}}),_c('option-list',{attrs:{"options":_vm.options}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }